import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=ab387b60"
import script from "./Create.vue?vue&type=script&setup=true&lang=js"
export * from "./Create.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports